import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import MultiSelectBox from '../../../../features/components/Form/MultiSelectBox'

import { getGoogleGeolocations } from '../../../../modules/actions/googleConstants'
import { selectedGoogleAdAccountSelector } from '../../../../modules/selectors/adAccounts'
import {
  googleGeolocationsIsLoadingSelector,
  googleGeolocationsSelector
} from '../../../../modules/selectors/googleConstants'

const GoogleGeolocationRegion = ({ selectedCountry, name, value, setFieldValue }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const geolocations = useSelector(googleGeolocationsSelector)
  const { id: selectedAdAccountId } = useSelector(selectedGoogleAdAccountSelector)
  const geolocationsIsLoading = useSelector(googleGeolocationsIsLoadingSelector)

  const formattedGeolocations = useMemo(
    () =>
      geolocations &&
      geolocations.map(item => {
        const { id, canonical_name, target_type, resource_name } = item

        return { value: id, label: canonical_name, type: target_type, resource_name }
      }),
    [geolocations]
  )

  const getGeolocations = useCallback(
    searchValue => {
      dispatch(
        getGoogleGeolocations({
          country_code: selectedCountry && selectedCountry.iso2,
          account: selectedAdAccountId,
          search: searchValue
        })
      )
    },
    [dispatch, selectedCountry, selectedAdAccountId]
  )

  const onSearchChange = useCallback(
    searchValue => {
      getGeolocations(searchValue)
    },
    [getGeolocations]
  )

  return (
    <MultiSelectBox
      placeholder={t('Add a region')}
      name={name}
      options={formattedGeolocations}
      value={value}
      isLoading={geolocationsIsLoading}
      setFieldValue={setFieldValue}
      onSearch={onSearchChange}
    />
  )
}

export default GoogleGeolocationRegion
